/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/require-computed-property-dependencies */
import Predicate from 'predicates/models/predicate';
import { equal, not, reads } from '@ember/object/computed';
import { typeOf } from '@ember/utils';
import { computed } from '@ember/object';
import { applyFunction } from '@intercom/pulse/lib/computed-properties';
import inflector from 'embercom/lib/inflector';
export default Predicate.extend({
  isEditable: true,
  genericType: 'datetime',
  defaultComparison: 'lt',
  typeOfValue: applyFunction(typeOf, 'value'),
  valueIsObject: equal('typeOfValue', 'object'),
  isRelativeDate: reads('valueIsObject'),
  isAbsoluteDate: not('isRelativeDate'),
  relativeDirection: computed('{info,value}.direction', function () {
    return this.info?.direction || this.value?.direction || 'past';
  }),
  isRelativePast: equal('relativeDirection', 'past'),
  isRelativeFuture: equal('relativeDirection', 'future'),
  isValidForValue: computed('value', function () {
    if (this.isRelativeDate) {
      return !!(this.value?.value && this.value?.unit);
    } else {
      return !!this.value;
    }
  }),
  getDefaultValue(context = {}) {
    return {
      value: 5,
      unit: 'minutes',
      direction: this.relativeDirection
    };
  },
  getDescription() {
    let comparison;
    if (this.isRelativePast) {
      comparison = this.comparison === 'lt' ? 'more than' : 'less than';
    } else {
      comparison = this.comparison === 'lt' ? 'less than' : 'more than';
    }

    // unit is pluralized, singular form is just without the 's' at the end for all of them
    let singular = this.value.unit.slice(0, -1);
    let unit = inflector(singular, this.value.value, this.value.unit);
    let shortText = `${comparison} ${this.value.value} ${unit}`;
    let descriptionSuffix = this.info?.suffix;
    if (descriptionSuffix) {
      shortText = `${shortText} ${descriptionSuffix}`;
    }
    return {
      shortText
    };
  },
  changeComparison(comparison) {
    this.setProperties({
      comparison: comparison.replace(/:(relative|absolute)/, ''),
      value: this._intializeValueForComparison(comparison)
    });
  },
  _intializeValueForComparison(comparison) {
    if (comparison === 'known' || comparison === 'unknown') {
      return null;
    } else if (comparison.endsWith('absolute') && (this.valueIsObject || this.valueIsNull)) {
      return new Date(); // or ISO string?
    } else if (comparison.endsWith('relative') && !this.valueIsObject) {
      return this.getDefaultValue();
    } else {
      return this.value;
    }
  },
  comparisonOptionValue: computed('comparison', 'isAbsoluteDate', 'isRelativeDate', function () {
    let comparison = this.comparison;
    if (this.isRelativeDate) {
      return `${comparison}:relative`;
    } else if (this.isAbsoluteDate) {
      return `${comparison}:absolute`;
    } else {
      return comparison;
    }
  })
});